module.exports = __webpack_public_path__ + "static/img/slider-caption.6e12f99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home2/slider-caption.png
// module id = IXWz
// module chunks = 36